import { useGetProperties } from '@practium/features/api';
import { useForBinding } from '../../../forBinding';
import {
	getMaintenanceReferenceId,
	getMaintenanceReferenceName,
} from '../../utils/maintenanceAdviceMapper';
import styles from './RecommendationSubtitle.module.css';

interface RecommendationSubtitleProps {
	text: string;
	property?: unknown;
}

const embeddedName = (property: unknown) =>
	property && typeof property === 'object' ? getMaintenanceReferenceName(property) : '';

export const RecommendationSubtitle = ({ text, property }: RecommendationSubtitleProps) => {
	const { isForBinding, forBindingUser } = useForBinding();
	const propertyId = getMaintenanceReferenceId(property);
	const knownName = embeddedName(property);
	const { data: properties = [] } = useGetProperties({
		limit: 300,
		enabled: isForBinding && !!propertyId && !knownName,
	});

	if (!isForBinding || !forBindingUser) return text;

	const userName = `${forBindingUser.name} ${forBindingUser.surName ?? ''}`.trim();
	const farmName = knownName || properties.find((item) => item._id === propertyId)?.name || '';

	return (
		<>
			{text} - <strong className={styles.highlight}>{userName}</strong>
			{farmName && (
				<>
					{' · '}
					<strong className={styles.highlight}>{farmName}</strong>
				</>
			)}
		</>
	);
};
